import React, { useRef, useEffect, useState } from 'react';
import HeadsImage from '../../assets/heads.png';
import TailsImage from '../../assets/tails.png';
import './SimpleCoin3D.css';

interface SimpleCoin3DProps {
  isFlipping: boolean;
  result?: 'heads' | 'tails';
  onFlipComplete?: () => void;
  size?: number;
}

const SimpleCoin3D: React.FC<SimpleCoin3DProps> = ({ 
  isFlipping, 
  result, 
  onFlipComplete,
  size = 80 
}) => {
  const coinRef = useRef<HTMLDivElement>(null);
  const [showResult, setShowResult] = useState(false);
  
  // Track previous isFlipping to detect transition
  const prevIsFlipping = useRef(false);


  useEffect(() => {
    // Only trigger animation when isFlipping transitions from false to true
    if (!prevIsFlipping.current && isFlipping && result && coinRef.current) {
      setShowResult(false);
      const spins = 4;
      const finalRotation = result === 'heads' ? 0 : 180;
      const totalRotation = spins * 360 + finalRotation;
      console.log(`Coin flip: result=${result}, finalRotation=${finalRotation}, totalRotation=${totalRotation}`);
      coinRef.current.style.transform = `rotateY(${totalRotation}deg)`;
      setTimeout(() => {
        setShowResult(true);
        onFlipComplete?.();
      }, 2000);
    }
    prevIsFlipping.current = isFlipping;
  }, [isFlipping, result, onFlipComplete]);

  return (
    <div className="simple-coin-container" style={{ width: size + 40, height: size + 60 }}>
      <div 
        ref={coinRef}
        className={`simple-coin ${isFlipping ? 'flipping' : ''}`}
        style={{ width: size, height: size }}
      >
        <div className="coin-side heads">
          <img src={HeadsImage} alt="Heads" />
        </div>
        <div className="coin-side tails">
          <img src={TailsImage} alt="Tails" />
        </div>
      </div>
      
      {showResult && result && (
        <div className="coin-result-text">
          {result.toUpperCase()}
        </div>
      )}
    </div>
  );
};

export default SimpleCoin3D;